export default {"src":"/_next/static/media/burger_open.6dea6d38.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};